<template>
  <v-container class="mt-4 px-5" fluid>
    <v-row>
      <v-col cols="12">
        <v-card class="shadowCard">
          <v-toolbar flat dense color="transparent">
            <v-icon color="primary" class="mr-2">mdi-chart-timeline-variant</v-icon>
            <v-toolbar-title class="subtitle-1 font-weight-bold">
              Simulación de calificación de leads
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn small tile color="primary" dark :to="{ name: 'Prospectos' }">
              <v-icon small left>mdi-arrow-left</v-icon>
              Prospectos
            </v-btn>
          </v-toolbar>

          <v-card-text class="pb-0">
            <v-alert type="info" dense outlined class="mb-0">
              <strong>Alta de lead de prueba:</strong> inserta en BD y calcula la calificación con las mismas reglas del CRM.
            </v-alert>
          </v-card-text>

          <v-tabs v-model="tab" background-color="transparent" class="px-4">
            <v-tab>Alta lead de prueba</v-tab>
            <v-tab>Prospectos existentes</v-tab>
          </v-tabs>
        </v-card>
      </v-col>
    </v-row>

    <!-- TAB: Alta lead de prueba -->
    <v-row v-show="tab === 0">
      <v-col cols="12" lg="7">
        <v-card class="shadowCard mb-4 mt-2">
          <v-card-title class="subtitle-2 py-3 d-flex align-center">
            Datos del lead
            <v-spacer></v-spacer>
            <v-btn small text color="grey darken-2" @click="reiniciarAltaLead">
              <v-icon small left>mdi-restore</v-icon>
              Reiniciar
            </v-btn>
          </v-card-title>
          <v-card-text class="pt-0">
            <v-row dense>
              <v-col cols="12" sm="6" md="4">
                <v-select
                  v-model="altaLead.escuela"
                  :items="escuelas"
                  item-text="text"
                  item-value="value"
                  label="Escuela *"
                  filled
                  dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="altaLead.telefono"
                  label="Teléfono *"
                  filled
                  dense
                  hide-details
                  hint="10 dígitos. Repite un teléfono existente + 'permitir duplicado' para probar recurrencia."
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="4">
                <v-text-field
                  v-model="altaLead.nombre_completo"
                  label="Nombre (opcional)"
                  filled
                  dense
                  hide-details
                  clearable
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete
                  v-model="altaLead.usuario_creo"
                  :items="usuariosErp"
                  item-text="nombre_completo"
                  item-value="id_usuario"
                  label="Usuario que sube *"
                  filled
                  dense
                  hide-details
                  clearable
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete
                  v-model="altaLead.usuario_asignado"
                  :items="usuariosErp"
                  item-text="nombre_completo"
                  item-value="id_usuario"
                  label="Usuario asignado"
                  filled
                  dense
                  hide-details
                  clearable
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-autocomplete
                  v-model="altaLead.sucursal_interes"
                  :items="plantelesFiltrados"
                  item-text="plantel"
                  item-value="idplantel"
                  label="Sucursal interés"
                  filled
                  dense
                  hide-details
                  clearable
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" sm="6" md="6">
                <v-checkbox
                  v-model="altaLead.permitir_duplicado"
                  label="Permitir duplicado (recurrencia)"
                  hide-details
                  dense
                  class="mt-0"
                ></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="shadowCard mb-4">
          <v-card-title class="subtitle-2 py-3">Origen</v-card-title>
          <v-card-text class="pt-0">
            <v-row dense>
              <v-col cols="12" md="6">
                <v-select
                  v-model="altaLead.origen_escenario"
                  :items="opcionesOrigenEscenario"
                  item-text="text"
                  item-value="value"
                  label="Escenario de origen"
                  filled
                  dense
                  hide-details
                  @change="aplicarEscenarioOrigenAlta"
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="altaLead.idfuentes"
                  :items="fuentes"
                  item-text="fuente"
                  item-value="idfuentes"
                  label="Fuente (catálogo) *"
                  filled
                  dense
                  hide-details
                  clearable
                  @change="altaLead.iddetalle_fuentes = null"
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="altaLead.iddetalle_fuentes"
                  :items="detallesFuenteFiltrados"
                  item-text="detalle_fuente"
                  item-value="iddetalle_fuentes"
                  label="Detalle fuente *"
                  filled
                  dense
                  hide-details
                  clearable
                  :disabled="!altaLead.idfuentes"
                  hint="Meta / Inbox = Facebook o Instagram + Mensajes"
                  persistent-hint
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6">
                <v-autocomplete
                  v-model="altaLead.idcampanias"
                  :items="campanias"
                  item-text="campania"
                  item-value="idcampanias"
                  label="Campaña (catálogo)"
                  filled
                  dense
                  hide-details
                  clearable
                ></v-autocomplete>
              </v-col>
              <v-col cols="12" md="6" v-if="altaLead.origen_escenario === 'meta_ads'">
                <v-text-field
                  v-model="altaLead.referral_source_url"
                  label="Referral URL (Meta Ads)"
                  filled
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" v-if="altaLead.origen_escenario === 'meta_ads'">
                <v-text-field
                  v-model="altaLead.referral_source_id"
                  label="Referral Source ID"
                  filled
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-card class="shadowCard mb-4">
          <v-card-title class="subtitle-2 py-3">Integridad, intención y velocidad</v-card-title>
          <v-card-text class="pt-0">
            <v-row dense>
              <v-col cols="12" md="6">
                <v-select
                  v-model="altaLead.integridad_modo"
                  :items="opcionesIntegridad"
                  item-text="text"
                  item-value="value"
                  label="Integridad Twilio"
                  filled
                  dense
                  hide-details
                ></v-select>
              </v-col>
              <v-col cols="12" md="6">
                <v-text-field
                  v-model.number="altaLead.minutos_bot"
                  type="number"
                  min="0.5"
                  step="0.5"
                  label="Minutos entre inicio y fin del bot"
                  filled
                  dense
                  hide-details
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" v-if="altaLead.integridad_modo !== 'incompleto'">
                <v-text-field v-model.number="altaLead.pregunta1" label="Pregunta 1 (ID opción)" type="number" filled dense hide-details></v-text-field>
              </v-col>
              <v-col cols="12" md="6" v-if="altaLead.integridad_modo !== 'incompleto'">
                <v-text-field v-model.number="altaLead.pregunta2" label="Pregunta 2 (ID opción)" type="number" filled dense hide-details></v-text-field>
              </v-col>
              <v-col cols="12" md="6" v-if="altaLead.integridad_modo !== 'incompleto'">
                <v-text-field v-model.number="altaLead.pregunta3" label="Pregunta 3 (ID opción)" type="number" filled dense hide-details></v-text-field>
              </v-col>
              <v-col cols="12" md="6" v-if="altaLead.integridad_modo !== 'incompleto'">
                <v-text-field v-model.number="altaLead.pregunta4" label="Pregunta 4 (ID opción)" type="number" filled dense hide-details></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="altaLead.primer_mensaje_lead"
                  label="Primer mensaje del lead"
                  filled
                  dense
                  hide-details
                  hint='Para Google usa "web"; para Influencer usa "historia"'
                  persistent-hint
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea
                  v-model="altaLead.mensaje_intencion"
                  label="Mensaje de intención (≥5 palabras, después del primero)"
                  filled
                  dense
                  rows="2"
                  auto-grow
                  hide-details
                ></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <v-btn color="primary" block tile large :loading="cargarAlta" @click="crearLeadPrueba">
          <v-icon left>mdi-database-plus</v-icon>
          Crear lead y clasificar
        </v-btn>
      </v-col>

      <v-col cols="12" lg="5">
        <v-alert v-if="!resultadoAltaLead" type="warning" dense outlined class="mt-2">
          Completa el formulario y pulsa <strong>Crear lead y clasificar</strong>. El resultado usará las reglas reales del backend.
        </v-alert>
        <PanelResultadoCalificacion
          v-if="resultadoAltaLead"
          :resultado="resultadoAltaLead"
          :niveles="niveles"
          :mostrar-criterios="true"
        />
        <v-card v-if="leadCreado" class="shadowCard mt-4">
          <v-card-text>
            <div class="subtitle-2 mb-2">Lead creado</div>
            <div><strong>Folio:</strong> {{ leadCreado.folio }}</div>
            <div><strong>ID:</strong> {{ leadCreado.idprospectos }}</div>
            <v-btn small color="primary" class="mt-3" @click="verLeadEnTabla">Ver en prospectos existentes</v-btn>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <!-- TAB: Prospectos -->
    <v-row v-show="tab === 1">
      <v-col cols="12">
        <v-card class="shadowCard mt-2">
          <v-card-text>
            <v-row dense align="center">
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="fechaini" type="date" label="Fecha inicio" outlined dense hide-details class="filtro-compacto"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3">
                <v-text-field v-model="fechafin" type="date" label="Fecha final" outlined dense hide-details class="filtro-compacto"></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="2">
                <v-select
                  v-model="filtroEscuela"
                  :items="escuelas"
                  item-text="text"
                  item-value="value"
                  label="Escuela"
                  outlined
                  dense
                  hide-details
                  clearable
                  class="filtro-compacto"
                ></v-select>
              </v-col>
              <v-col cols="6" sm="4" md="4">
                <v-btn color="primary" small tile class="mr-2" @click="consultarProspectos" :loading="cargar">
                  Consultar
                </v-btn>

                <v-btn color="green" dark small tile class="mr-2" @click="exportarTablaExcel" :disabled="!prospectosTabla.length || cargar">
                  <v-icon x-small left>mdi-microsoft-excel</v-icon>
                  Excel
                </v-btn>
                
                <v-btn color="indigo" dark small tile class="mr-2" @click="dialogCasos = true">
                  <v-icon x-small left>mdi-format-list-checks</v-icon>
                  Casos
                </v-btn>

                <v-btn color="deep-purple" dark small tile @click="abrirModalPuntajes">
                  <v-icon x-small left>mdi-tune</v-icon>
                  Puntajes
                </v-btn>

              </v-col>
              
              <v-col cols="6" sm="4" md="2">
                <v-text-field
                  v-model="filtroCaso"
                  label="Caso"
                  type="number"
                  outlined
                  dense
                  hide-details
                  clearable
                  class="filtro-compacto"
                ></v-text-field>
              </v-col>
            </v-row>

            <v-row dense class="mt-2" align="center">
              <v-col cols="12" sm="4" md="3">
                <v-chip
                  small
                  class="mr-2 mb-1 chip-filtro"
                  color="green"
                  :dark="!filtroNivel || filtroNivel === 'alta'"
                  :outlined="!!filtroNivel && filtroNivel !== 'alta'"
                  @click="toggleFiltroNivel('alta')"
                >Alta: {{ conteoNiveles.alta }}</v-chip>
                <v-chip
                  small
                  class="mr-2 mb-1 chip-filtro"
                  color="orange"
                  :dark="!filtroNivel || filtroNivel === 'media'"
                  :outlined="!!filtroNivel && filtroNivel !== 'media'"
                  @click="toggleFiltroNivel('media')"
                >Media: {{ conteoNiveles.media }}</v-chip>
                <v-chip
                  small
                  class="mr-2 mb-1 chip-filtro"
                  color="blue-grey"
                  :dark="!filtroNivel || filtroNivel === 'baja'"
                  :outlined="!!filtroNivel && filtroNivel !== 'baja'"
                  @click="toggleFiltroNivel('baja')"
                >Baja: {{ conteoNiveles.baja }}</v-chip>
                <v-btn
                  v-if="filtroNivel || filtroOrigen"
                  x-small
                  text
                  color="primary"
                  class="px-1"
                  @click="limpiarFiltros"
                >Limpiar filtros</v-btn>
              </v-col>
            </v-row>

            <v-row dense class="mt-1 filtros-variables-row">
              <v-col cols="6" sm="4" md="2" lg="2">
                <v-select
                  v-model="filtroVariableOrigen"
                  :items="opcionesFiltroOrigenVariable"
                  item-text="text"
                  item-value="value"
                  label="Origen"
                  outlined
                  dense
                  hide-details
                  clearable
                  class="filtro-compacto"
                ></v-select>
              </v-col>
              <v-col cols="6" sm="4" md="2" lg="2">
                <v-select
                  v-model="filtroVariableIntegridad"
                  :items="opcionesFiltroIntegridad"
                  item-text="text"
                  item-value="value"
                  label="Integridad"
                  outlined
                  dense
                  hide-details
                  clearable
                  class="filtro-compacto"
                ></v-select>
              </v-col>
              <v-col cols="6" sm="4" md="2" lg="2">
                <v-select
                  v-model="filtroVariableIntencion"
                  :items="opcionesFiltroIntencion"
                  item-text="text"
                  item-value="value"
                  label="Intención"
                  outlined
                  dense
                  hide-details
                  clearable
                  class="filtro-compacto"
                ></v-select>
              </v-col>
              <v-col cols="6" sm="4" md="2" lg="2">
                <v-select
                  v-model="filtroVariableVelocidad"
                  :items="opcionesFiltroVelocidad"
                  item-text="text"
                  item-value="value"
                  label="Velocidad"
                  outlined
                  dense
                  hide-details
                  clearable
                  class="filtro-compacto"
                ></v-select>
              </v-col>
              <v-col cols="6" sm="4" md="2" lg="2">
                <v-select
                  v-model="filtroVariableRecurrencia"
                  :items="opcionesFiltroRecurrencia"
                  item-text="text"
                  item-value="value"
                  label="Recurrencia"
                  outlined
                  dense
                  hide-details
                  clearable
                  class="filtro-compacto"
                ></v-select>
              </v-col>
              <v-col cols="6" sm="4" md="2" lg="2" class="d-flex align-center">
                <v-btn block x-small text color="primary" @click="limpiarFiltrosVariables">
                  Limpiar
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>

          <v-data-table
            :headers="headersProspectos"
            :items="prospectosTabla"
            :search="search"
            dense
            elevation="0"
            :loading="cargar"
            item-key="idprospectos"
            class="px-2 pb-4"
            :items-per-page="25"
            @click:row="abrirDetalle"
          >
            <template v-slot:item.acciones="{ item }">
              <v-btn
                v-if="tieneContactoTwilio(item)"
                icon
                x-small
                color="green"
                title="Ver conversación"
                @click.stop="abrirConversacion(item)"
              >
                <v-icon small>mdi-whatsapp</v-icon>
              </v-btn>
            </template>
            <template v-slot:item.origenMatriz="{ item }">
              <span
                class="celda-evidencia"
                title="Ver evidencia de origen"
                @click.stop="abrirEvidenciaMatriz(item, 'origen', item.origenMatriz)"
              >
                <strong>{{ item.origenMatriz }}</strong>
                <v-icon x-small class="ml-1 grey--text">mdi-information-outline</v-icon>
              </span>
            </template>
            <template v-slot:item.matrizIntegridad="{ item }">
              <span
                class="celda-evidencia"
                title="Ver evidencia de integridad"
                @click.stop="abrirEvidenciaMatriz(item, 'integridad', item.matrizIntegridad)"
              >
                <strong>{{ item.matrizIntegridad }}</strong>
                <v-icon x-small class="ml-1 grey--text">mdi-information-outline</v-icon>
              </span>
            </template>
            <template v-slot:item.matrizIntencion="{ item }">
              <span
                class="celda-evidencia"
                title="Ver evidencia de intención"
                @click.stop="abrirEvidenciaMatriz(item, 'intencion', item.matrizIntencion)"
              >
                <strong>{{ item.matrizIntencion }}</strong>
                <v-icon x-small class="ml-1 grey--text">mdi-information-outline</v-icon>
              </span>
            </template>
            <template v-slot:item.matrizVelocidad="{ item }">
              <span
                class="celda-evidencia"
                title="Ver evidencia de velocidad"
                @click.stop="abrirEvidenciaMatriz(item, 'velocidad', item.matrizVelocidad)"
              >
                <strong>{{ item.matrizVelocidad }}</strong>
                <v-icon x-small class="ml-1 grey--text">mdi-information-outline</v-icon>
              </span>
            </template>
            <template v-slot:item.matrizRecurrencia="{ item }">
              <span
                class="celda-evidencia"
                title="Ver evidencia de recurrencia"
                @click.stop="abrirEvidenciaMatriz(item, 'recurrencia', item.matrizRecurrencia)"
              >
                <strong>{{ item.matrizRecurrencia }}</strong>
                <v-icon x-small class="ml-1 grey--text">mdi-information-outline</v-icon>
              </span>
            </template>
            <template v-slot:item.puntajeTotal="{ item }">
              <div>
                <strong>{{ item.puntajeTotal }}</strong>
                <div v-if="item.matrizDesgloseSuma" class="text-caption grey--text text-no-wrap">
                  {{ item.matrizDesgloseSuma }}
                </div>
              </div>
            </template>
            <template v-slot:item.calificacionMatriz="{ item }">
              <v-chip x-small :color="item.nivel && item.nivel.chipColor" dark>
                {{ item.calificacionMatriz }}
              </v-chip>
            </template>
          </v-data-table>

          <v-alert type="warning" dense outlined class="mx-4 mb-4" v-if="prospectosCalificados.length">
            Cada celda muestra <strong>flag (puntos)</strong>, p. ej. <strong>1 (30)</strong>. Haz clic en Origen, Integridad, Intención, Velocidad o Recurrencia para ver la evidencia (mensaje, link, regla aplicada).
            Velocidad <strong>0</strong> = 5 pts, <strong>1</strong> = 20 pts.
            Puntaje total = Origen + Integridad + Intención + Velocidad + Recurrencia (+ bonificación si aplica; máx. 205 pts).
            <strong>Intent_Category:</strong> Alta (130+), Media (80–129), Baja (&lt;80).
            La sábana oficial tiene <strong>{{ TOTAL_CASOS_CALIFICACION_LEADS }} casos</strong> (folios 1–{{ TOTAL_CASOS_CALIFICACION_LEADS }}).
          </v-alert>
        </v-card>
      </v-col>
    </v-row>

    <!-- Detalle prospecto -->
    <v-dialog v-model="dialogDetalle" max-width="1000" scrollable>
      <v-card v-if="prospectoSeleccionado">
        <v-card-title class="subtitle-1">
          {{ prospectoSeleccionado.folio }} — {{ prospectoSeleccionado.nombre_completo }}
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialogDetalle = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-tabs v-model="tabDetalle" background-color="transparent" class="px-4">
          <v-tab>Calificación</v-tab>
          <v-tab :disabled="!tieneContactoTwilio(prospectoSeleccionado)">
            Conversación
            <v-icon x-small right v-if="tieneContactoTwilio(prospectoSeleccionado)">mdi-whatsapp</v-icon>
          </v-tab>
        </v-tabs>
        <v-divider></v-divider>
        <v-card-text>
          <div v-show="tabDetalle === 0">
            <v-row dense class="mb-3">
              <v-col cols="6" md="3"><span class="text-caption grey--text">Origen</span><br>{{ prospectoSeleccionado.origenLabel || '—' }}</v-col>
              <v-col cols="6" md="3"><span class="text-caption grey--text">Puesto creador</span><br>{{ prospectoSeleccionado.puesto_creador || '—' }}</v-col>
              <v-col cols="6" md="3"><span class="text-caption grey--text">Teléfono</span><br>{{ prospectoSeleccionado.telefono }}</v-col>
              <v-col cols="6" md="3"><span class="text-caption grey--text">Vendedora</span><br>{{ prospectoSeleccionado.vendedora || '—' }}</v-col>
              <v-col cols="6" md="3"><span class="text-caption grey--text">Sucursal</span><br>{{ prospectoSeleccionado.sucursal_nombre || '—' }}</v-col>
              <v-col cols="6" md="3"><span class="text-caption grey--text">Etapa</span><br>{{ etiquetaEtapa(prospectoSeleccionado.idetapa_calc) }}</v-col>
              <v-col cols="6" md="3" v-if="prospectoSeleccionado.palabras_max_lead">
                <span class="text-caption grey--text">Intención (palabras)</span><br>{{ prospectoSeleccionado.palabras_max_lead }}
              </v-col>
            </v-row>

            <PanelResultadoCalificacion
              :resultado="prospectoSeleccionado"
              :niveles="niveles"
              :mostrar-criterios="true"
            />
          </div>

          <div v-show="tabDetalle === 1">
            <ConversacionTwilioLectura
              v-if="tieneContactoTwilio(prospectoSeleccionado)"
              :key="prospectoSeleccionado.idprospectos"
              :escuela="prospectoSeleccionado.escuela"
              :twilio="prospectoSeleccionado.twilio"
              :telefono="prospectoSeleccionado.telefono"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogCasos" max-width="1300" scrollable>
      <v-card>
        <v-card-title class="subtitle-1">
          Casos faltantes y configuración esperada
          <v-spacer></v-spacer>
          <v-chip small color="primary" dark class="mr-2">Catálogo: {{ TOTAL_CASOS_CALIFICACION_LEADS }} casos</v-chip>
          <v-chip small color="warning" dark class="mr-2">Faltantes: {{ casosFaltantes.length }}</v-chip>
          <v-btn small tile color="primary" dark class="mr-2" :loading="cargar" @click="consultarDesdeCasosFaltantes">
            Consultar ahora
          </v-btn>
          <v-btn icon small @click="dialogCasos = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-alert type="info" dense outlined class="mb-3">
            Casos de la matriz que <strong>no aparecen en la última consulta</strong> del tab
            <em>Prospectos existentes</em> ({{ fechaini }} — {{ fechafin }}).
            Tras crear un lead con <strong>Cargar → Crear</strong>, pulsa <strong>Consultar ahora</strong> para actualizar el conteo.
            Revisa que el rango de fechas incluya hoy, la escuela sea la correcta y
            <strong>Solo mis prospectos</strong> esté desactivado si el lead lo creó otro usuario.
          </v-alert>
          <v-alert color="blue-grey lighten-5" border="left" colored-border dense class="mb-3">
            <strong>Leyenda 1/0:</strong>
            Formato <strong>flag (puntos)</strong>: Integridad <strong>1 (30)</strong> / <strong>0 (0)</strong> ·
            Intención <strong>1 (40)</strong> / <strong>0 (0)</strong> ·
            Velocidad <strong>1 (20)</strong> / <strong>0 (5)</strong> ·
            Recurrencia <strong>1 (15)</strong> / <strong>0 (5)</strong>.
            Con datos incompletos (0), la velocidad siempre es <strong>0</strong>.
          </v-alert>
          <v-data-table
            :headers="headersCasos"
            :items="casosFaltantes"
            dense
            elevation="0"
            :items-per-page="25"
            item-key="caso"
          >
            <template v-slot:item.origenLabel="{ item }">
              <strong>{{ item.origenLabel }} ({{ item.origenPuntos }})</strong>
            </template>
            <template v-slot:item.integridad="{ item }">
              <strong>{{ formatearCeldaCatalogoMatriz(item.integridad, 'integridad') }}</strong>
            </template>
            <template v-slot:item.intencion="{ item }">
              <strong>{{ formatearCeldaCatalogoMatriz(item.intencion, 'intencion') }}</strong>
            </template>
            <template v-slot:item.velocidad="{ item }">
              <strong>{{ formatearCeldaCatalogoMatriz(item.velocidad, 'velocidad') }}</strong>
            </template>
            <template v-slot:item.recurrencia="{ item }">
              <strong>{{ formatearCeldaCatalogoMatriz(item.recurrencia, 'recurrencia') }}</strong>
            </template>
            <template v-slot:item.puntajeEsperado="{ item }">
              <div>
                <strong>{{ item.puntajeEsperado }}</strong>
                <div class="text-caption grey--text text-no-wrap">{{ desgloseSumaCatalogo(item) }}</div>
              </div>
            </template>
            <template v-slot:item.acciones="{ item }">
              <v-btn x-small tile color="primary" dark @click="cargarCasoEnFormulario(item)">
                Cargar
              </v-btn>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogEvidenciaMatriz" max-width="680" scrollable>
      <v-card v-if="evidenciaMatrizSeleccionada">
        <v-card-title class="subtitle-1">
          Evidencia — {{ evidenciaMatrizSeleccionada.titulo }}
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialogEvidenciaMatriz = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-subtitle class="pb-0">
          {{ evidenciaMatrizSeleccionada.folio }}
          <span v-if="evidenciaMatrizSeleccionada.nombre"> — {{ evidenciaMatrizSeleccionada.nombre }}</span>
          · Celda: <strong>{{ evidenciaMatrizSeleccionada.valorCelda }}</strong>
        </v-card-subtitle>
        <v-divider class="mt-2"></v-divider>
        <v-card-text>
          <v-alert
            v-if="evidenciaMatrizSeleccionada.regla"
            type="info"
            dense
            outlined
            class="mb-3"
          >
            <strong>Regla aplicada:</strong> {{ evidenciaMatrizSeleccionada.regla }}
          </v-alert>
          <v-list dense v-if="evidenciaMatrizSeleccionada.lineas.length">
            <v-list-item
              v-for="(linea, idx) in evidenciaMatrizSeleccionada.lineas"
              :key="`${linea.etiqueta}-${idx}`"
              class="px-0"
            >
              <v-list-item-content>
                <v-list-item-title class="text-caption grey--text">{{ linea.etiqueta }}</v-list-item-title>
                <v-list-item-subtitle class="text-body-2 evidencia-valor">
                  <a
                    v-if="linea.esLink"
                    :href="linea.valor"
                    target="_blank"
                    rel="noopener noreferrer"
                  >{{ linea.valor }}</a>
                  <span v-else>{{ linea.valor }}</span>
                </v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
          <v-alert v-else type="warning" dense outlined>
            Sin evidencia adicional registrada para esta categoría.
          </v-alert>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            v-if="evidenciaMatrizSeleccionada.prospecto && tieneContactoTwilio(evidenciaMatrizSeleccionada.prospecto)"
            text
            small
            color="green"
            @click="abrirConversacionDesdeEvidencia"
          >
            <v-icon small left>mdi-whatsapp</v-icon>
            Ver conversación
          </v-btn>
          <v-btn text small color="primary" @click="dialogEvidenciaMatriz = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogPuntajes" max-width="720" scrollable persistent>
      <v-card>
        <v-card-title class="subtitle-1 py-2">
          Editar puntajes de calificación
          <v-spacer></v-spacer>
          <v-btn icon small @click="dialogPuntajes = false"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text class="pt-0">
          <v-alert type="info" dense outlined class="mb-3 text-caption">
            Ajusta los puntos por criterio. Al guardar se persisten en BD y se recalcula la tabla visible.
            <span v-if="puntajesMeta.updated_at" class="d-block mt-1">
              Última actualización: {{ formatearFechaPuntajes(puntajesMeta.updated_at) }}
            </span>
          </v-alert>
          <v-data-table
            :headers="headersPuntajes"
            :items="filasPuntajesEditables"
            dense
            hide-default-footer
            :items-per-page="-1"
            class="tabla-puntajes"
          >
            <template v-slot:item.grupo="{ item }">
              <span class="text-caption font-weight-medium">{{ item.grupo }}</span>
            </template>
            <template v-slot:item.etiqueta="{ item }">
              <span class="text-caption">{{ item.etiqueta }}</span>
            </template>
            <template v-slot:item.puntos="{ item }">
              <v-text-field
                v-model.number="item.puntos"
                type="number"
                min="0"
                dense
                outlined
                hide-details
                class="input-puntos"
              ></v-text-field>
            </template>
          </v-data-table>
        </v-card-text>
        <v-card-actions>
          <v-btn text small color="grey" @click="restaurarPuntajesDefault">Restaurar defaults</v-btn>
          <v-spacer></v-spacer>
          <v-btn text small @click="dialogPuntajes = false">Cancelar</v-btn>
          <v-btn color="primary" small tile :loading="guardarPuntajes" @click="aplicarPuntajesYRecalcular">
            Guardar y recalcular
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <carga v-if="cargar" />
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import carga from '@/components/alertas/carga.vue'
import validarErrores from '@/mixins/validarErrores'
import funcionesExcel from '@/mixins/funcionesExcel'
import PanelResultadoCalificacion from '@/components/prospectos/PanelResultadoCalificacion.vue'
import ConversacionTwilioLectura from '@/components/prospectos/ConversacionTwilioLectura.vue'
import { tieneContactoTwilio } from '@/utils/twilioUsuario'
import {
  NIVELES_CALIFICACION_LEADS,
  TOTAL_CASOS_CALIFICACION_LEADS,
  buildCasosCatalogo,
  calcularCalificacionDesdeProspecto,
  esCasoCalificacionValido,
  resolverCasoDesdeProspecto,
  resolverCalificacionEsperada,
  formatearCeldaCatalogoMatriz,
  formatearDesgloseSumaPuntos,
  puntosOficialesPorFlag,
  prospectoCoincideConCasoCatalogo,
  cargarConfigPuntajesDesdeApi,
  guardarConfigPuntajesEnApi,
  crearConfigPuntajesEditable,
  filasEditablePuntajes,
  sincronizarConfigDesdeFilas,
  resolverDesglosePuntosConConfig,
  resolverPuntajeConConfig,
} from '@/utils/calificacionLeads'

function crearAltaLeadInicial() {
  return {
    escuela: 1,
    telefono: '',
    nombre_completo: '',
    usuario_creo: null,
    usuario_asignado: null,
    sucursal_interes: null,
    permitir_duplicado: false,
    origen_escenario: 'sucursal',
    idfuentes: null,
    iddetalle_fuentes: null,
    idcampanias: null,
    referral_source_url: '',
    referral_source_id: '',
    integridad_modo: 'completo',
    pregunta1: 1,
    pregunta2: 1,
    pregunta3: 1,
    pregunta4: 1,
    primer_mensaje_lead: 'Hola, quiero información',
    mensaje_intencion: 'Me interesa mucho el curso de inglés por favor',
    minutos_bot: 2,
    simular_usuario_anterior: false,
    folio_caso_objetivo: null,
  }
}

const ETIQUETAS_ETAPA = {
  1: 'Atrasado',
  2: 'Nuevo',
  3: 'Inducción',
  4: 'Con info',
  5: 'Sin info',
}

export default {
  name: 'SimulacionCalificacionLeads',

  components: { carga, PanelResultadoCalificacion, ConversacionTwilioLectura },

  mixins: [validarErrores, funcionesExcel],

  data: () => ({
    TOTAL_CASOS_CALIFICACION_LEADS,
    tab: 0,
    niveles: NIVELES_CALIFICACION_LEADS,
    altaLead: crearAltaLeadInicial(),
    resultadoAltaLead: null,
    leadCreado: null,
    cargarAlta: false,
    usuariosErp: [],
    planteles: [],
    fuentes: [],
    detallesFuentes: [],
    campanias: [],
    opcionesOrigenEscenario: [
      { text: 'Sucursal', value: 'sucursal' },
      { text: 'Recomendación', value: 'recomendacion' },
      { text: 'Llamada', value: 'llamada' },
      { text: 'Google (Web)', value: 'google_web' },
      { text: 'Meta Ads', value: 'meta_ads' },
      { text: 'Influencer', value: 'influencer' },
      { text: 'WhatsApp Directo (Mkt)', value: 'whatsapp_directo_mkt' },
      { text: 'Meta / Inbox', value: 'meta_inbox' },
      { text: 'Meta / Comentario', value: 'meta_comentario' },
      { text: 'Desconocido', value: 'desconocido' },
    ],
    opcionesIntegridad: [
      { text: 'Twilio completo (4 preguntas)', value: 'completo' },
      { text: 'Twilio incompleto', value: 'incompleto' },
      { text: 'Manual (preguntas personalizadas)', value: 'manual' },
    ],
    fechaini: new Date(Date.now() - 30 * 24 * 60 * 60 * 1000).toISOString().substr(0, 10),
    fechafin: new Date().toISOString().substr(0, 10),
    filtroEscuela: null,
    configPuntajes: crearConfigPuntajesEditable(),
    puntajesMeta: { updated_at: null, updated_by: null },
    guardarPuntajes: false,
    filasPuntajesEditables: [],
    dialogPuntajes: false,
    escuelas: [
      { text: 'INBI', value: 1 },
      { text: 'FAST', value: 2 },
    ],
    prospectosRaw: [],
    prospectosCalificados: [],
    filtroNivel: null,
    filtroOrigen: null,
    search: '',
    cargar: false,
    dialogDetalle: false,
    dialogEvidenciaMatriz: false,
    evidenciaMatrizSeleccionada: null,
    dialogCasos: false,
    tabDetalle: 0,
    prospectoSeleccionado: null,
    filtroVariableOrigen: null,
    filtroVariableIntegridad: null,
    filtroVariableIntencion: null,
    filtroVariableVelocidad: null,
    filtroVariableRecurrencia: null,
    filtroCaso: null,
    opcionesFiltroOrigenVariable: [
      { text: 'Sucursal', value: 'origen_sucursal' },
      { text: 'Recomendación', value: 'origen_recomendacion' },
      { text: 'Llamada', value: 'origen_llamada' },
      { text: 'Google (Web)', value: 'origen_google_web' },
      { text: 'Meta Ads', value: 'origen_meta_ads' },
      { text: 'Influencer', value: 'origen_influencer' },
      { text: 'WhatsApp Directo (Mkt)', value: 'origen_whatsapp_directo_mkt' },
      { text: 'Meta / Inbox', value: 'origen_meta_inbox' },
      { text: 'Meta / Comentario', value: 'origen_meta_comentario' },
      { text: 'Desconocido', value: 'origen_desconocido' },
    ],
    opcionesFiltroIntegridad: [
      { text: 'Datos Completos', value: 'integridad_completo' },
      { text: 'Datos Incompletos', value: 'integridad_incompleto' },
    ],
    opcionesFiltroIntencion: [
      { text: 'Respuesta >= 5 palabras', value: 'intencion_5_palabras' },
      { text: 'Respuesta < 5 palabras', value: 'intencion_menor_5_palabras' },
    ],
    opcionesFiltroVelocidad: [
      { text: 'Llenado <= 3 min', value: 'velocidad_llenado_menor_igual_3_min' },
      { text: 'Llenado > 3 min', value: 'velocidad_llenado_mayor_3_min' },
    ],
    opcionesFiltroRecurrencia: [
      { text: 'Usuario Nuevo', value: 'recurrencia_usuario_nuevo' },
      { text: 'Usuario Anterior', value: 'recurrencia_usuario_anterior' },
    ],
    headersCasos: [
      { text: 'Caso', value: 'caso', align: 'center' },
      { text: 'Origen', value: 'origenLabel' },
      { text: 'Integridad (1=Completo, 0=Incompleto)', value: 'integridad', align: 'center' },
      { text: 'Intención (1=>=5 palabras, 0=<5 palabras)', value: 'intencion', align: 'center' },
      { text: 'Velocidad (1=<=3 min, 0=>3 min)', value: 'velocidad', align: 'center' },
      { text: 'Recurrencia (1=Nuevo, 0=Anterior)', value: 'recurrencia', align: 'center' },
      { text: 'Puntaje esperado', value: 'puntajeEsperado', align: 'center' },
      { text: 'Calificación esperada', value: 'calificacionEsperada' },
      { text: 'Encontrados', value: 'encontrados', align: 'center' },
      { text: '', value: 'acciones', sortable: false, width: '120px' },
    ],
    headersPuntajes: [
      { text: 'Sección', value: 'grupo', sortable: false },
      { text: 'Criterio', value: 'etiqueta', sortable: false },
      { text: 'Puntos', value: 'puntos', sortable: false, width: '110px', align: 'center' },
    ],
    headersProspectos: [
      { text: '', value: 'acciones', sortable: false, width: '48px' },
      { text: 'Folio', value: 'folio' },
      { text: 'Caso', value: 'folio_caso', align: 'center' },
      { text: 'Sucursal interés', value: 'sucursal_interes_label' },
      { text: 'Ciudad', value: 'ciudad_contacto' },
      { text: 'Modalidad', value: 'modalidad_label' },
      { text: 'Curso interés', value: 'curso_interes_label' },
      { text: 'Origen', value: 'origenMatriz' },
      { text: 'Integridad (1=Completos, 0=Incompleto)', value: 'matrizIntegridad', align: 'center' },
      { text: 'Intención (1=>=5 palabras, 0=<5 palabras)', value: 'matrizIntencion', align: 'center' },
      { text: 'Velocidad (1=<=3 min, 0=>3 min)', value: 'matrizVelocidad', align: 'center' },
      { text: 'Recurrencia (1=Nuevo, 0=Anterior)', value: 'matrizRecurrencia', align: 'center' },
      { text: 'Puntaje_Esperado', value: 'puntajeTotal', align: 'center' },
      { text: 'Calificación', value: 'calificacionMatriz' },
    ],
  }),

  computed: {
    ...mapGetters('login', ['getdatosUsuarioERPERP']),

    esVendedora() {
      return this.getdatosUsuarioERPERP.idpuesto === 18
    },

    plantelesFiltrados() {
      if (!this.altaLead.escuela) return this.planteles
      return this.planteles.filter((p) => Number(p.escuela) === Number(this.altaLead.escuela))
    },

    detallesFuenteFiltrados() {
      if (!this.altaLead.idfuentes) return []
      return this.detallesFuentes.filter((d) => Number(d.idfuentes) === Number(this.altaLead.idfuentes))
    },

    conteoNiveles() {
      return this.prospectosCalificados.reduce(
        (acc, p) => {
          if (p.nivel.id === 3) acc.alta += 1
          else if (p.nivel.id === 2) acc.media += 1
          else acc.baja += 1
          return acc
        },
        { alta: 0, media: 0, baja: 0 }
      )
    },

    conteoOrigen() {
      return this.prospectosCalificados.reduce(
        (acc, p) => {
          const tipo = p.origenScoringId || p.origen
          if (tipo === 'sucursal' || tipo === 'recomendacion' || tipo === 'llamada') acc.sucursal += 1
          else if (tipo === 'meta_inbox' || tipo === 'meta_comentario' || tipo === 'meta_ads') acc.meta += 1
          else acc.otro += 1
          return acc
        },
        { sucursal: 0, meta: 0, otro: 0 }
      )
    },

    prospectosTabla() {
      let items = this.prospectosCalificados

      if (this.filtroNivel) {
        const nivelPorFiltro = { alta: 3, media: 2, baja: 1 }
        const idNivel = nivelPorFiltro[this.filtroNivel]
        items = items.filter((p) => p.nivel && p.nivel.id === idNivel)
      }

      if (this.filtroOrigen) {
        items = items.filter((p) => {
          const tipo = p.origenScoringId || p.origen
          if (this.filtroOrigen === 'sucursal') {
            return tipo === 'sucursal' || tipo === 'recomendacion' || tipo === 'llamada'
          }
          if (this.filtroOrigen === 'meta') return tipo === 'meta_inbox' || tipo === 'meta_comentario' || tipo === 'meta_ads'
          return tipo !== 'sucursal' && tipo !== 'recomendacion' && tipo !== 'llamada' && tipo !== 'meta_inbox' && tipo !== 'meta_comentario' && tipo !== 'meta_ads'
        })
      }

      if (this.filtroVariableOrigen) {
        items = items.filter((p) => this.criterioActivo(p, this.filtroVariableOrigen))
      }
      if (this.filtroVariableIntegridad) {
        items = items.filter((p) => this.criterioActivo(p, this.filtroVariableIntegridad))
      }
      if (this.filtroVariableIntencion) {
        items = items.filter((p) => this.criterioActivo(p, this.filtroVariableIntencion))
      }
      if (this.filtroVariableVelocidad) {
        items = items.filter((p) => this.criterioActivo(p, this.filtroVariableVelocidad))
      }
      if (this.filtroVariableRecurrencia) {
        items = items.filter((p) => this.criterioActivo(p, this.filtroVariableRecurrencia))
      }
      if (this.filtroCaso !== null && this.filtroCaso !== '') {
        const caso = Number(this.filtroCaso)
        if (!Number.isNaN(caso)) {
          items = items.filter((p) => resolverCasoDesdeProspecto(p) === caso)
        }
      }

      return items
    },

    casosCatalogo() {
      return buildCasosCatalogo()
    },

    casosConEstado() {
      return this.casosCatalogo.map((cat) => ({
        ...cat,
        encontrados: this.prospectosCalificados.filter((p) => prospectoCoincideConCasoCatalogo(p, cat)).length,
      }))
    },

    casosFaltantes() {
      return this.casosConEstado.filter((c) => c.encontrados === 0)
    },
  },

  mounted() {
    this.altaLead.usuario_creo = this.getdatosUsuarioERPERP.iderp
    this.altaLead.usuario_asignado = this.getdatosUsuarioERPERP.iderp
    this.cargarCatalogosAltaLead()
    this.cargarConfigPuntajesDesdeBd()
  },

  methods: {
    cargarConfigPuntajesDesdeBd() {
      return cargarConfigPuntajesDesdeApi(this.$http)
        .then((data) => {
          this.configPuntajes = data.config
          this.puntajesMeta = {
            updated_at: data.updated_at,
            updated_by: data.updated_by,
          }
        })
        .catch(() => {
          this.configPuntajes = crearConfigPuntajesEditable()
        })
    },

    formatearFechaPuntajes(fecha) {
      if (!fecha) return ''
      try {
        return new Date(fecha).toLocaleString('es-MX')
      } catch (_) {
        return String(fecha)
      }
    },
    cargarCatalogosAltaLead() {
      this.$http.get('usuarios.erp.get.usuariosERP').then((response) => {
        this.usuariosErp = response.data || []
      }).catch(() => {})
      this.$http.get('planteles.all').then((response) => {
        this.planteles = response.data || []
      }).catch(() => {})
      this.$http.get('fuentes.activos').then((response) => {
        this.fuentes = response.data || []
      }).catch(() => {})
      this.$http.get('fuentes.detalle.activos').then((response) => {
        this.detallesFuentes = response.data || []
      }).catch(() => {})
      this.$http.get('campanias.activos').then((response) => {
        this.campanias = response.data || []
      }).catch(() => {})
    },

    reiniciarAltaLead() {
      this.altaLead = crearAltaLeadInicial()
      this.altaLead.usuario_creo = this.getdatosUsuarioERPERP.iderp
      this.altaLead.usuario_asignado = this.getdatosUsuarioERPERP.iderp
      this.resultadoAltaLead = null
      this.leadCreado = null
    },

    crearLeadPrueba() {
      if (!this.altaLead.telefono) {
        return this.validarErrorDirecto('Indica el teléfono del lead')
      }
      if (!this.altaLead.usuario_creo) {
        return this.validarErrorDirecto('Indica el usuario que sube el lead')
      }

      this.cargarAlta = true
      const payload = this.sanitizarPayloadAltaLead(
        Object.assign({}, this.altaLead, {
          usuario_asignado: this.altaLead.usuario_asignado || this.altaLead.usuario_creo,
        })
      )

      return this.$http
        .post('prospectos.calificacion.leads.crear', payload)
        .then((response) => {
          const prospecto = response.data.prospecto || response.data
          this.leadCreado = prospecto
          this.resultadoAltaLead = prospecto.desgloseSecciones
            ? prospecto
            : calcularCalificacionDesdeProspecto(prospecto)

          const casoObj = this.altaLead.folio_caso_objetivo
          const casoReal = prospecto.folio_caso
          if (casoObj && Number(casoReal) !== Number(casoObj)) {
            this.validarErrorDirecto(
              `Lead creado (folio ${prospecto.folio}) pero caso ${casoReal} ≠ esperado ${casoObj}. Revisa usuario/origen.`
            )
          } else {
            this.validarSuccess(response.data.message || 'Lead creado y clasificado')
            this.consultarProspectos()
          }
        })
        .catch((error) => {
          const msg = (error.body && error.body.message) || error.message || 'Error al crear lead'
          this.validarErrorDirecto(msg)
        })
        .finally(() => {
          this.cargarAlta = false
        })
    },

    sanitizarPayloadAltaLead(raw) {
      const p = Object.assign({}, raw)
      const enteros = [
        'escuela', 'sucursal_interes', 'usuario_creo', 'usuario_asignado',
        'idfuentes', 'iddetalle_fuentes', 'idcampanias', 'idcurso', 'idmodalidad', 'edad',
        'pregunta1', 'pregunta2', 'pregunta3', 'pregunta4', 'minutos_bot',
      ]
      enteros.forEach((key) => {
        const val = p[key]
        if (val === null || val === '' || val === undefined || (typeof val === 'number' && Number.isNaN(val))) {
          delete p[key]
        }
      })
      if (!p.minutos_bot || Number.isNaN(Number(p.minutos_bot))) p.minutos_bot = 2
      if (p.origen_escenario !== 'meta_ads') {
        delete p.referral_source_url
        delete p.referral_source_id
        delete p.referral_headline
        delete p.referral_ctwa_clid
        delete p.referral_body
      }
      return p
    },

    aplicarEscenarioOrigenAlta() {
      const escenario = this.altaLead.origen_escenario
      if (escenario === 'meta_inbox') {
        this.seleccionarFuenteDetallePorPatron(['instagram', 'facebook'], 'mensaje')
      } else if (escenario === 'meta_comentario') {
        this.seleccionarFuenteDetallePorPatron(['instagram', 'facebook'], 'comentario')
      }
    },

    seleccionarFuenteDetallePorPatron(fuentesPreferidas, detallePatron) {
      const patron = String(detallePatron || '').toLowerCase()
      const detalle = this.detallesFuentes.find((d) => {
        const nombreFuente = String(d.fuente || '').toLowerCase()
        const nombreDetalle = String(d.detalle_fuente || '').toLowerCase()
        const fuenteOk = fuentesPreferidas.some((f) => nombreFuente.includes(f))
        return fuenteOk && nombreDetalle.includes(patron)
      })
      if (!detalle) return
      this.altaLead.idfuentes = detalle.idfuentes
      this.altaLead.iddetalle_fuentes = detalle.iddetalle_fuentes
    },

    telefonoPruebaPorCaso(caso) {
      const offset = Number(this._telOffsetPrueba || 0)
      const n = 5500000000 + offset + Number(caso)
      return String(n).slice(-10)
    },

    cargarCasoEnFormulario(item) {
      if (!item) return
      this._telOffsetPrueba = Date.now() % 50000
      this.reiniciarAltaLead()
      const caso = Number(item.caso)

      this.altaLead.origen_escenario = item.origenId
      this.altaLead.integridad_modo = item.integridad ? 'completo' : 'incompleto'
      this.altaLead.minutos_bot = item.velocidad ? 2 : 5
      this.altaLead.mensaje_intencion = item.intencion
        ? 'Me interesa mucho el curso de inglés por favor informes'
        : 'ok gracias'
      this.altaLead.simular_usuario_anterior = !item.recurrencia
      this.altaLead.permitir_duplicado = !item.recurrencia
      this.altaLead.telefono = this.telefonoPruebaPorCaso(caso)
      this.altaLead.folio_caso_objetivo = caso
      this.aplicarEscenarioOrigenAlta()

      if (item.origenId === 'google_web') {
        this.altaLead.primer_mensaje_lead = 'quiero información web del curso'
      } else if (item.origenId === 'influencer') {
        this.altaLead.primer_mensaje_lead = 'vi tu historia y quiero información'
      } else if (item.origenId === 'meta_ads') {
        this.altaLead.referral_source_url = 'https://fb.me/prueba-calificacion'
        this.altaLead.referral_source_id = `TEST_CASE_${caso}`
      } else {
        this.altaLead.primer_mensaje_lead = 'Hola, quiero información'
        this.altaLead.referral_source_url = ''
        this.altaLead.referral_source_id = ''
        this.altaLead.idfuentes = null
        this.altaLead.iddetalle_fuentes = null
        this.altaLead.idcampanias = null
      }

      if (item.origenId === 'whatsapp_directo_mkt') {
        this.validarSuccess('Caso WhatsApp Mkt: elige un usuario de mercadotecnia (puesto KPI 25, 48, 49, 54, 62, 74, 97 o 101).')
      }

      if (item.origenId === 'sucursal') {
        this.validarSuccess('Caso sucursal: elige un usuario con puesto de sucursal (KPI 18, 19 o 73).')
      }

      if (!item.recurrencia) {
        this.validarSuccess('Recurrencia=0: se activó "Simular usuario anterior" y "Permitir duplicado".')
      }

      this.tab = 0
      this.dialogCasos = false
      this.validarSuccess(`Caso ${caso} cargado — revisa y pulsa Crear`)
    },

    verLeadEnTabla() {
      if (!this.leadCreado) return
      this.tab = 1
      const hoy = new Date().toISOString().substr(0, 10)
      this.fechaini = hoy
      this.fechafin = hoy
      this.filtroEscuela = this.leadCreado.escuela
      this.consultarProspectos().then(() => {
        const encontrado = this.prospectosCalificados.find(
          (p) => p.idprospectos === this.leadCreado.idprospectos
        )
        if (encontrado) this.abrirDetalle(encontrado)
      })
    },

    etiquetaEtapa(idetapa) {
      return ETIQUETAS_ETAPA[idetapa] || `Etapa ${idetapa}`
    },

    tieneContactoTwilio,

    consultarDesdeCasosFaltantes() {
      const hoy = new Date().toISOString().substr(0, 10)
      if (!this.fechaini || this.fechaini > hoy) this.fechaini = hoy
      if (!this.fechafin || this.fechafin < hoy) this.fechafin = hoy
      return this.consultarProspectos()
    },

    consultarProspectos() {
      if (!this.fechaini || !this.fechafin) {
        return this.validarErrorDirecto('Selecciona fecha inicio y final')
      }

      this.cargar = true
      const payload = {
        fechaini: this.fechaini,
        fechafin: this.fechafin,
      }

      if (this.filtroEscuela && Number.isFinite(Number(this.filtroEscuela))) {
        payload.escuela = Number(this.filtroEscuela)
      }

      if (this.esVendedora) {
        payload.usuario_asignado = this.getdatosUsuarioERPERP.iderp
      }

      return this.$http
        .post('prospectos.calificacion.leads', payload)
        .then((response) => {
          const datos = response.data || []
          const vistos = new Set()
          this.prospectosRaw = datos.filter((p) => {
            const id = Number(p.idprospectos)
            if (!Number.isFinite(id) || id <= 0 || vistos.has(id)) return false
            vistos.add(id)
            return true
          })
          this.filtroNivel = null
          this.filtroOrigen = null
          this.prospectosCalificados = this.prospectosRaw.map((prospecto) => {
            const calificacion = prospecto.desgloseSecciones
              ? {
                  puntajeTotal: prospecto.puntajeTotal,
                  puntajeBruto: prospecto.puntajeBruto,
                  puntajeMaximo: prospecto.puntajeMaximo,
                  porcentaje: prospecto.porcentaje,
                  nivel: prospecto.nivel,
                  desgloseSecciones: prospecto.desgloseSecciones,
                  criteriosActivos: prospecto.criteriosActivos,
                  criteriosTotales: prospecto.criteriosTotales,
                  criteriosSinDatos: prospecto.criteriosSinDatos,
                  criteriosEvaluables: prospecto.criteriosEvaluables,
                  completitudDatos: prospecto.completitudDatos,
                  origenLabel: prospecto.origenLabel,
                  origenScoringId: prospecto.origenScoringId,
                  intentCategory: prospecto.intentCategory,
                  folio_caso: prospecto.folio_caso,
                }
              : calcularCalificacionDesdeProspecto(prospecto)
            const fila = {
              ...prospecto,
              ...calificacion,
            }
            fila.folio_caso = resolverCasoDesdeProspecto(fila)
            return this.aplicarPuntajesConfigAFila(fila)
          })
        })
        .catch((error) => {
          const mensaje =
            (error.body && error.body.message) ||
            (error.response && error.response.data && error.response.data.message) ||
            'Error al consultar'
          this.validarError(mensaje)
        })
        .finally(() => {
          this.cargar = false
        })
    },

    abrirModalPuntajes() {
      this.filasPuntajesEditables = filasEditablePuntajes(this.configPuntajes).map((f) => ({ ...f }))
      this.dialogPuntajes = true
    },

    restaurarPuntajesDefault() {
      this.configPuntajes = crearConfigPuntajesEditable()
      this.filasPuntajesEditables = filasEditablePuntajes(this.configPuntajes).map((f) => ({ ...f }))
    },

    aplicarPuntajesYRecalcular() {
      this.configPuntajes = sincronizarConfigDesdeFilas(this.configPuntajes, this.filasPuntajesEditables)
      this.guardarPuntajes = true
      return guardarConfigPuntajesEnApi(this.$http, {
        config: this.configPuntajes,
        filas: this.filasPuntajesEditables,
        usuario_erp: this.getdatosUsuarioERPERP.iderp,
      })
        .then((data) => {
          this.configPuntajes = data.config
          this.puntajesMeta = {
            updated_at: data.updated_at,
            updated_by: data.updated_by,
          }
          this.prospectosCalificados = this.prospectosCalificados.map((p) => this.aplicarPuntajesConfigAFila({ ...p }))
          this.dialogPuntajes = false
          this.validarSuccess(data.message || 'Puntajes guardados y tabla recalculada.')
        })
        .catch((error) => {
          const mensaje =
            (error.body && error.body.message) ||
            (error.response && error.response.data && error.response.data.message) ||
            'Error al guardar puntajes'
          this.validarErrorDirecto(mensaje)
        })
        .finally(() => {
          this.guardarPuntajes = false
        })
    },

    aplicarPuntajesConfigAFila(fila) {
      const desglose = resolverDesglosePuntosConConfig(fila, this.configPuntajes)
      if (desglose) {
        fila.puntajeTotal = desglose.total
        fila.porcentaje = Math.round((desglose.total / (fila.puntajeMaximo || 205)) * 100)
        const nivelSlug = resolverCalificacionEsperada(desglose.total).toLowerCase()
        const nivel = NIVELES_CALIFICACION_LEADS.find((n) => n.slug === nivelSlug)
        if (nivel) {
          fila.nivel = nivel
          fila.intentCategory = nivel.intentCategory
        }
      }
      return Object.assign(fila, this.construirFilaMatriz(fila))
    },

    abrirDetalle(item) {
      this.prospectoSeleccionado = item
      this.tabDetalle = 0
      this.dialogDetalle = true
    },

    abrirConversacion(item) {
      this.prospectoSeleccionado = item
      this.tabDetalle = 1
      this.dialogDetalle = true
    },

    abrirEvidenciaMatriz(item, seccionId, valorCelda) {
      this.evidenciaMatrizSeleccionada = {
        ...this.construirEvidenciaMatriz(item, seccionId),
        valorCelda,
        prospecto: item,
      }
      this.dialogEvidenciaMatriz = true
    },

    abrirConversacionDesdeEvidencia() {
      const item = this.evidenciaMatrizSeleccionada && this.evidenciaMatrizSeleccionada.prospecto
      if (!item) return
      this.dialogEvidenciaMatriz = false
      this.abrirConversacion(item)
    },

    agregarLineaEvidencia(lineas, etiqueta, valor, esLink = false) {
      if (valor === null || valor === undefined) return
      const texto = String(valor).trim()
      if (!texto) return
      lineas.push({
        etiqueta,
        valor: texto,
        esLink: esLink || /^https?:\/\//i.test(texto),
      })
    },

    etiquetaEstadoCriterio(estado) {
      if (estado === 'cumple') return 'Cumple'
      if (estado === 'no_cumple') return 'No cumple'
      if (estado === 'sin_datos') return 'Sin datos en sistema'
      return estado || '—'
    },

    construirEvidenciaMatriz(item, seccionId) {
      const titulos = {
        origen: 'Origen',
        integridad: 'Integridad',
        intencion: 'Intención',
        velocidad: 'Velocidad',
        recurrencia: 'Recurrencia',
      }
      const criterio = this.obtenerCriterioActivo(item, seccionId)
      const lineas = []

      if (criterio) {
        this.agregarLineaEvidencia(lineas, 'Criterio asignado', criterio.etiqueta)
        this.agregarLineaEvidencia(lineas, 'Estado evaluación', this.etiquetaEstadoCriterio(criterio.estado))
      }

      if (seccionId === 'origen') {
        this.agregarLineaEvidencia(lineas, 'Primer mensaje del lead', item.primer_mensaje_lead)
        this.agregarLineaEvidencia(lineas, 'Referral URL (Facebook/Meta)', item.referral_source_url, true)
        this.agregarLineaEvidencia(lineas, 'Referral Source ID', item.referral_source_id)
        const meta = item.referral_meta || {}
        this.agregarLineaEvidencia(lineas, 'Referral URL (Twilio)', meta.ReferralSourceUrl, true)
        this.agregarLineaEvidencia(lineas, 'Referral Headline', meta.ReferralHeadline)
        this.agregarLineaEvidencia(lineas, 'Referral Body', meta.ReferralBody)
        this.agregarLineaEvidencia(lineas, 'Referral Ctwa Clid', meta.ReferralCtwaClid)
        this.agregarLineaEvidencia(lineas, 'Fuente (catálogo)', item.fuente)
        this.agregarLineaEvidencia(lineas, 'Detalle fuente', item.detalle_fuente)
        this.agregarLineaEvidencia(lineas, 'Campaña', item.campania)
        this.agregarLineaEvidencia(lineas, 'Medio de contacto', item.medio_contacto)
        this.agregarLineaEvidencia(lineas, 'Nota inicial', item.nota_inicial)
        this.agregarLineaEvidencia(lineas, 'Cómo llegó', item.como_llego)
        this.agregarLineaEvidencia(lineas, 'Puesto creador', item.puesto_creador)
        if (item.tiene_referral_meta) {
          this.agregarLineaEvidencia(lineas, 'Referral Meta detectado', 'Sí')
        }
      }

      if (seccionId === 'integridad') {
        const preguntas = ['pregunta1', 'pregunta2', 'pregunta3', 'pregunta4']
          .map((k, idx) => `P${idx + 1}: ${Number(item[k]) ? 'Respondida' : 'Sin respuesta'}`)
          .join(' · ')
        this.agregarLineaEvidencia(lineas, 'Flujo Twilio (4 preguntas)', preguntas)
        this.agregarLineaEvidencia(lineas, 'Twilio contacto', item.twilio || item.telefono)
      }

      if (seccionId === 'intencion') {
        this.agregarLineaEvidencia(lineas, 'Ventana evaluada', 'Mensajes del lead (sin el primero) durante el flujo del bot, antes del cierre automático y de la vendedora')
        if (item.mensaje_intencion_referencia) {
          this.agregarLineaEvidencia(
            lineas,
            `Mensaje evaluado (${Number(item.palabras_mensaje_intencion || 0)} palabras)`,
            `"${item.mensaje_intencion_referencia}"`
          )
        }
        if (item.fecha_mensaje_intencion) {
          this.agregarLineaEvidencia(lineas, 'Fecha del mensaje', item.fecha_mensaje_intencion)
        }
        if (item.palabras_max_sin_primer_mensaje != null) {
          this.agregarLineaEvidencia(
            lineas,
            'Máx. palabras (sin primer mensaje, hasta fin bot)',
            String(item.palabras_max_sin_primer_mensaje)
          )
        }
      }

      if (seccionId === 'velocidad') {
        if (item.minutos_llenado != null && item.minutos_llenado !== undefined) {
          this.agregarLineaEvidencia(
            lineas,
            'Tiempo de llenado del bot',
            `${Number(item.minutos_llenado).toFixed(1)} minutos`
          )
        }
        this.agregarLineaEvidencia(lineas, 'Inicio bot (1er mensaje)', item.bot_inicio_ts)
        this.agregarLineaEvidencia(lineas, 'Fin bot (último mensaje)', item.bot_fin_ts)
        if (item.minutos_bot != null) {
          this.agregarLineaEvidencia(lineas, 'Minutos bot (resumen)', String(item.minutos_bot))
        }
      }

      if (seccionId === 'recurrencia') {
        const esAnterior = !!Number(item.es_usuario_anterior)
        this.agregarLineaEvidencia(
          lineas,
          'Historial en CRM',
          esAnterior ? 'Usuario anterior (ya existía registro previo)' : 'Usuario nuevo (primer ingreso)'
        )
        this.agregarLineaEvidencia(lineas, 'Campo es_usuario_anterior', esAnterior ? '1 (anterior)' : '0 (nuevo)')
      }

      const regla = criterio && criterio.detalle ? criterio.detalle : ''

      return {
        titulo: titulos[seccionId] || seccionId,
        seccionId,
        folio: item.folio || '—',
        nombre: item.nombre_completo || '',
        regla,
        lineas,
      }
    },

    toggleFiltroNivel(nivel) {
      this.filtroNivel = this.filtroNivel === nivel ? null : nivel
    },

    toggleFiltroOrigen(origen) {
      this.filtroOrigen = this.filtroOrigen === origen ? null : origen
    },

    limpiarFiltros() {
      this.filtroNivel = null
      this.filtroOrigen = null
    },

    limpiarFiltrosVariables() {
      this.filtroVariableOrigen = null
      this.filtroVariableIntegridad = null
      this.filtroVariableIntencion = null
      this.filtroVariableVelocidad = null
      this.filtroVariableRecurrencia = null
    },

    exportarTablaExcel() {
      const items = this.prospectosTabla
      if (!items.length) {
        this.validarError('No hay prospectos en la tabla para exportar')
        return
      }

      const dataExport = items.map((item) => ({
        Folio: item.folio || '',
        Caso: item.folio_caso != null ? item.folio_caso : '',
        Sucursal_Interes: item.sucursal_interes_label || '',
        Ciudad: item.ciudad_contacto || '',
        Modalidad: item.modalidad_label || '',
        Curso_Interes: item.curso_interes_label || '',
        Origen: item.origenMatriz || '',
        Integridad: item.matrizIntegridad != null ? item.matrizIntegridad : '',
        Intencion: item.matrizIntencion != null ? item.matrizIntencion : '',
        Velocidad: item.matrizVelocidad != null ? item.matrizVelocidad : '',
        Recurrencia: item.matrizRecurrencia != null ? item.matrizRecurrencia : '',
        Puntaje_Esperado: item.puntajeTotal != null ? item.puntajeTotal : '',
        Calificacion: item.calificacionMatriz || (item.nivel ? item.nivel.nombre : ''),
      }))

      const fecha = String(this.fechaini || '').replace(/\//g, '-')
      const nombreArchivo = `calificacion_leads_${fecha || 'consulta'}`
      this.exportarExcelDirecto(dataExport, nombreArchivo)
    },

    exportarSabanaExcel() {
      const dataExport = this.casosCatalogo.map((cat) => {
        const item = this.prospectosCalificados.find((p) => prospectoCoincideConCasoCatalogo(p, cat))
        if (item) {
          return {
            Folio: item.folio || '',
            Sucursal_Interes: item.sucursal_interes_label || '',
            Ciudad: item.ciudad_contacto || '',
            Modalidad: item.modalidad_label || '',
            Curso_Interes: item.curso_interes_label || '',
            Origen: item.origenMatriz || cat.origenLabel,
            Integridad: item.matrizIntegridad,
            Intencion: item.matrizIntencion,
            Velocidad: item.matrizVelocidad,
            Recurrencia: item.matrizRecurrencia,
            Desglose_Suma: item.matrizDesgloseSuma || '',
            Puntaje_Esperado: item.puntajeTotal != null ? item.puntajeTotal : cat.puntajeEsperado,
            Calificacion: item.calificacionMatriz || cat.calificacionEsperada,
            Caso: cat.caso,
            Estado: 'Encontrado',
          }
        }
        return this.filaMatrizDesdeCatalogo(cat)
      })

      this.exportarExcelDirecto(dataExport, 'matriz_calificacion_leads')
    },

    filaMatrizDesdeCatalogo(cat) {
      return {
        Folio: '',
        Origen: cat.origenLabel,
        Integridad: formatearCeldaCatalogoMatriz(cat.integridad, 'integridad'),
        Intencion: formatearCeldaCatalogoMatriz(cat.intencion, 'intencion'),
        Velocidad: formatearCeldaCatalogoMatriz(cat.velocidad, 'velocidad'),
        Recurrencia: formatearCeldaCatalogoMatriz(cat.recurrencia, 'recurrencia'),
        Desglose_Suma: this.desgloseSumaCatalogo(cat),
        Puntaje_Esperado: cat.puntajeEsperado,
        Calificacion: cat.calificacionEsperada,
        Caso: cat.caso,
        Estado: 'Pendiente',
      }
    },

    resumenCalificacion(item) {
      const secciones = item.desgloseSecciones || []
      return secciones.map((seccion) => {
        const criterioActivo = (seccion.criterios || []).find((c) => c.activo)
        return {
          id: seccion.id,
          titulo: seccion.titulo,
          puntos: seccion.puntosObtenidos || 0,
          texto: criterioActivo
            ? `${criterioActivo.etiqueta}. ${criterioActivo.detalle || seccion.detalle || ''}`.trim()
            : seccion.detalle || 'Sin detalle',
        }
      })
    },

    criterioActivo(item, criterioId) {
      const secciones = item.desgloseSecciones || []
      return secciones.some((seccion) =>
        (seccion.criterios || []).some((criterio) => criterio.id === criterioId && criterio.activo)
      )
    },

    valorBinarioCriterio(item, criterioIdSi) {
      return this.criterioActivo(item, criterioIdSi) ? 1 : 0
    },

    etiquetaOrigenMatriz(item) {
      const id = item.origenScoringId || ''
      const map = {
        sucursal: 'Sucursal',
        recomendacion: 'Recomendacion',
        llamada: 'Llamada',
        whatsapp_directo_mkt: 'WhatsApp Directo',
        google_web: 'Google (Web)',
        meta_ads: 'Meta Ads',
        influencer: 'Influencer',
        meta_inbox: 'Meta / Inbox',
        meta_comentario: 'Meta / Comentario',
        desconocido: 'Desconocido',
      }
      return map[id] || item.origenLabel || ''
    },

    desgloseSumaCatalogo(cat) {
      const partes = {
        origen: cat.origenPuntos,
        integridad: puntosOficialesPorFlag('integridad', cat.integridad),
        intencion: puntosOficialesPorFlag('intencion', cat.intencion),
        velocidad: puntosOficialesPorFlag('velocidad', cat.velocidad),
        recurrencia: puntosOficialesPorFlag('recurrencia', cat.recurrencia),
      }
      return formatearDesgloseSumaPuntos(partes, 0, cat.puntajeEsperado)
    },

    construirFilaMatriz(item) {
      const desglose = resolverDesglosePuntosConConfig(item, this.configPuntajes)
      const puntajeMatriz = desglose ? desglose.total : resolverPuntajeConConfig(item, this.configPuntajes)
      const calificacionMatriz = puntajeMatriz != null
        ? resolverCalificacionEsperada(puntajeMatriz)
        : (item.nivel ? item.nivel.nombre : '')

      if (desglose) {
        return {
          origenMatriz: desglose.origenTexto,
          matrizIntegridad: desglose.integridadTexto,
          matrizIntencion: desglose.intencionTexto,
          matrizVelocidad: desglose.velocidadTexto,
          matrizRecurrencia: desglose.recurrenciaTexto,
          matrizDesgloseSuma: desglose.desgloseSuma,
          calificacionMatriz,
        }
      }

      const integridad = this.valorBinarioCriterio(item, 'integridad_completo')
      const intencion = this.valorBinarioCriterio(item, 'intencion_5_palabras')
      const velocidad = this.valorBinarioCriterio(item, 'velocidad_llenado_menor_igual_3_min')
      const recurrencia = this.valorBinarioCriterio(item, 'recurrencia_usuario_nuevo')

      return {
        origenMatriz: this.etiquetaOrigenMatriz(item),
        matrizIntegridad: formatearCeldaCatalogoMatriz(integridad, 'integridad'),
        matrizIntencion: formatearCeldaCatalogoMatriz(intencion, 'intencion'),
        matrizVelocidad: formatearCeldaCatalogoMatriz(velocidad, 'velocidad'),
        matrizRecurrencia: formatearCeldaCatalogoMatriz(recurrencia, 'recurrencia'),
        matrizDesgloseSuma: '',
        calificacionMatriz,
      }
    },

    evidenciaIntencionTexto(item) {
      const criterioIntencion = this.obtenerCriterioActivo(item, 'intencion')
      if (!criterioIntencion) return 'Sin evidencia de intención'
      if (item.mensaje_intencion_referencia) {
        return `${Number(item.palabras_mensaje_intencion || 0)} palabras en: "${item.mensaje_intencion_referencia}"`
      }
      return criterioIntencion.detalle || 'Sin evidencia de intención'
    },

    evidenciaVelocidadTexto(item) {
      const criterioVelocidad = this.obtenerCriterioActivo(item, 'velocidad')
      if (!criterioVelocidad) return 'Sin evidencia de llenado'
      if (item.bot_inicio_ts && item.bot_fin_ts && item.minutos_llenado !== null && item.minutos_llenado !== undefined) {
        return `${Number(item.minutos_llenado).toFixed(1)} min (${item.bot_inicio_ts} -> ${item.bot_fin_ts})`
      }
      return criterioVelocidad.detalle || 'Sin evidencia de llenado'
    },

    obtenerCriterioActivo(item, seccionId) {
      const seccion = (item.desgloseSecciones || []).find((s) => s.id === seccionId)
      if (!seccion) return null
      return (seccion.criterios || []).find((c) => c.activo) || null
    },
  },
}
</script>

<style scoped>
.filtro-compacto >>> .v-input__control {
  min-height: 32px !important;
}

.filtro-compacto >>> .v-input__slot {
  min-height: 32px !important;
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.filtro-compacto >>> .v-label {
  font-size: 12px;
}

.filtro-compacto >>> fieldset {
  top: -4px;
}

.buscar-compacto {
  max-width: 240px;
  display: inline-block;
  vertical-align: middle;
}

.input-puntos {
  max-width: 90px;
}

.tabla-puntajes >>> td {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.chip-filtro {
  cursor: pointer;
}

.celda-evidencia {
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.28);
  padding-bottom: 1px;
}

.celda-evidencia:hover {
  color: #1976d2;
}

.celda-evidencia:hover .v-icon {
  color: #1976d2 !important;
}

.evidencia-valor {
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
